import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/sale/salePage.tsx");
